// extracted by mini-css-extract-plugin
export default {"description":"style_description__+eWNF","fade-in":"style_fade-in__7ctNY","top":"style_top__CN0IX","image":"style_image__kPjls"};